<template>
  <div class="tab-nav clearfix c-333">
    <div :class="tab==1?'active':''" @click="routerSkip('/about')">{{$t("header.nav2_1")}}</div>
    <div :class="tab==3?'active':''"  @click="routerSkip('/culture')">{{$t("header.nav2_2")}}</div>
    <div :class="tab==4?'active':''"  @click="routerSkip('/prize')">{{$t("header.nav2_3")}}</div>
    <div :class="tab==2?'active':''"  @click="routerSkip('/news')">{{$t("header.nav2_4")}}</div>
    <!-- <div :class="tab==4?'active':''"  @click="routerSkip('/download')">素材下载</div> -->
  </div>
</template>

<script>

  export default {
      props:['tab'],
    data () {
      return {


      }
    },
    created () {
      this.getList()
    },
    methods: {
      getList() {

      }
    }
  }
</script>
<style lang="stylus" scoped>

  .tab-nav>div{width:25%;}
  @media screen and (max-width: 768px){

    .English{
      .tab-nav{font-size:0.24rem; }
      .tab-nav>div{width:27%;}
      .tab-nav>div:first-child{width:19%}
      
  }
  }

</style>
<style >
  </style>
